import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AdminAccountForm, UsersPermissionsPageFilterForm } from 'src/app/shared/interfaces';
import { DataWithPagination } from '../../interface';
import { UsersPermissionsApi } from '../api/users-permissions-api';
import { AdminQuery } from '../model';
import { Repository } from './repository';
import { AuthUser } from '../model/auth-user-model';
import { JwtDecoderService } from '../../helper';
import { AccountDataModel } from '../model/account-data-model';

@Injectable({
  providedIn: 'root',
})
export class UsersPermissionsRepository extends Repository {
  public currentUser$: BehaviorSubject<AuthUser> = new BehaviorSubject(null);

  constructor(private usersPermissionsApi: UsersPermissionsApi, private jwtDecoderService: JwtDecoderService) {
    super();
    this.currentUser$.next(this.jwtDecoderService.getCurrentUserFromJWT());
  }

  getAdminsList(filter: UsersPermissionsPageFilterForm): Observable<DataWithPagination<AdminQuery[]>> {
    return this.usersPermissionsApi.getAdminsList(filter);
  }

  getUser(id: string): Observable<AccountDataModel> {
    return this.usersPermissionsApi.getUser(id)
  }

  addUser(form: AdminAccountForm): Observable<AdminQuery> {
    return this.usersPermissionsApi.addUser(form);
  }

  updateUser(admin: AdminAccountForm) : Observable<string>{
    return this.usersPermissionsApi.updateUser(admin);
  }
}
